// extracted by mini-css-extract-plugin
module.exports = {"ColorFinishSelector":"ColorFinishSelectorUI_ColorFinishSelector__Xsf57"};